import React, { ElementType, FC } from "react"
import xss from "xss"

import { convertStringToKebabCase, generateConditionalClassName, oneLineHelpScout } from "@utils"

type LpSectionTitleProps = {
  className?: string,
  tagName?: ElementType,
  title: string
  useDisplayFont?: boolean,
  useLargerFontSize?: boolean,
  useLeftTextAlign?: boolean | null,
}

export const LpSectionTitle: FC<LpSectionTitleProps> = ({
  className,
  tagName,
  title,
  useDisplayFont,
  useLargerFontSize,
  useLeftTextAlign,
}) => {
  const id = convertStringToKebabCase(title)
  const isSplitTitle = !useDisplayFont && title.match(/<br>|<br\/>|<br \/>/)
  const Tag = tagName || "h2"

  if (isSplitTitle) {
    const splitTitle = title.split(/<br>|<br\/>|<br \/>/)
    return (
      <Tag
        className={generateConditionalClassName({
          "column": true,
          "column--2-12-M column--3-11-L": !useLeftTextAlign,
          "column--1-11-M column--1-8-L": !!useLeftTextAlign,
          [`${className}`]: !!className,
        })}
        id={id}
      >
        <span
          className="type--serif-6XL font-weight--normal"
          dangerouslySetInnerHTML={{ __html: splitTitle[0] }}
        />
        <br />
        <span
          className="type--headline-bold-5XL"
          dangerouslySetInnerHTML={{ __html: splitTitle[1] }}
        />
      </Tag>
    )
  }

  return (
    <Tag
      className={generateConditionalClassName({
        "column": true,
        "type--display-9XL": !!useDisplayFont,
        "column--2-12-M column--3-11-L": !useLeftTextAlign,
        "column--1-11-M column--1-8-L": !!useLeftTextAlign,
        "font-size--6XL": !!useLargerFontSize,
        [`${className}`]: !!className,
      })}
      dangerouslySetInnerHTML={{ __html: oneLineHelpScout(xss(title)) }}
      id={id}
    />
  )
}

export default LpSectionTitle
